'use client'

import closeIcon from '@public/images/close_white.svg'
import Image from 'next/image'

export const TopNavV6MobileCloseHeader = ({ onClick }: { onClick: any }) => {
  return (
    <div className="flex h-12 items-center justify-end px-4">
      <button
        className="flex size-6 appearance-none items-center justify-center"
        onClick={onClick}
        data-testid="closeMobileMenu"
      >
        <Image src={closeIcon} width={20} height={20} alt="Close menu" />
      </button>
    </div>
  )
}
